import '../../resources/css/settings/SettingsNotificationForm.scss';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { verifyForm, verifyNumber, verifyAccount } from './../common/access-form-validation';
import { getFormValues, reduxForm, Field } from 'redux-form';
import { Row, Col, Button } from 'react-bootstrap';
import { checkTableAuth } from '../../components/common/access-auth';
import { commonRenderInput } from '../common/access-form';
import Loading from '../common/Loading';
import { popupModalConfirm, openModalAlert, openModalTip } from './../../actions/index';
import { doGetNotifySettings, doSaveNotifySettings, SAVE_NOTIFICATION_SETTING_SUCCESS, doTestSMTPEmail, TEST_SMTP_EMAIL_SUCCESS } from './../../actions/settings/index';


class NotificationForm extends Component {

    componentDidMount() {
        const { doGetNotifySettings, authToken, selectSite } = this.props;
        doGetNotifySettings(authToken, selectSite);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { doGetNotifySettings, authToken, selectSite, status, openModalTip } = this.props;

        if (prevProps.selectSite !== selectSite) {
            doGetNotifySettings(authToken, selectSite);
        }

        if ((prevProps.status !== status) && (status === SAVE_NOTIFICATION_SETTING_SUCCESS)) {
            doGetNotifySettings(authToken, selectSite);
        }

        if ((prevProps.status !== status) && (status === TEST_SMTP_EMAIL_SUCCESS)) {
            openModalTip('Test SMTP confirmation email sent successfully. Please check email inbox.');
        }
    }

    formSubmit = (values) => {
        const { authToken, accountRole, roleTableAuth, popupModalConfirm, verifyFormPass, openModalAlert, doSaveNotifySettings, selectSite, formValues } = this.props;

        if (checkTableAuth('settings', accountRole, roleTableAuth, 2)) {
            if (verifyFormPass) {
                popupModalConfirm('Confirm', 'icon-alert', 'Confirm to save change ?', 300, () => doSaveNotifySettings(authToken, selectSite, formValues), null, false);
            } else {
                openModalAlert("Some column is empty, please input data.");
            }
        } else {
            openModalAlert("Sorry, you don't have permission to change config.");
        }
    }


    testSMTPEmail = () => {
        const { doTestSMTPEmail, authToken, accountRole, formValues } = this.props;
        doTestSMTPEmail(authToken, accountRole, formValues);
    }


    render() {
        const { handleSubmit, mailSetting, verifyFormPass, accountRole, roleTableAuth /*, disabled */ } = this.props;

        let btnSubmit = (
            <div>
                <Row className='row-button'>
                    <Col md={2} xl={4}>&nbsp;</Col>
                    <Col md={8} xl={4}>
                        <Button id="notification-form-save" className="area-notify-settings-button" type="submit" variant="primary" size="lg" disabled={ !checkTableAuth('settings', accountRole, roleTableAuth, 2) } block>Save</Button>
                    </Col>
                    <Col md={2} xl={4}>&nbsp;</Col>
                </Row>
                {/* <Row className='row-button'>
                    <Col md={2} xl={4}>&nbsp;</Col>
                    <Col md={8} xl={4}>
                        <Button className="area-notify-settings-button" variant="primary" size="lg" onClick={ () => { this.testSMTPEmail(); alert("Email sent"); }} disabled={!verifyFormPass} block>Test SMTP</Button>
                    </Col>
                    <Col md={2} xl={4}>&nbsp;</Col>
                </Row> */}
            </div>
        );

        if (mailSetting) {
            return (
                <div className="notify-setting-form form-custom">
                    <div className="form-title">
                        <label className='area-form-title'>Notification Settings</label>
                        <label className='area-form-value'>You must configure Google's SMTP server before system can send alert notifications.</label>
                    </div>
                    <form id="notification-form" onSubmit={handleSubmit(this.formSubmit)} >
                        <div>
                            <Row className='row-id'>
                                <Col sm={12} >
                                    <div className='area-form-label'>
                                        <label className='need-star-label'>*</label><label>Id</label>
                                    </div>
                                    <div className='area-form-field'>
                                        <Field id="notification-form-id" type="text" name="id" component={commonRenderInput} disabled={true} />
                                    </div>
                                </Col>
                            </Row>
                            <Row className='row-smtp-host'>
                                <Col sm={12} >
                                    <div className='area-form-label'>
                                        <label className='need-star-label'>*</label><label>Email SMTP Host</label>
                                    </div>
                                    <div className='area-form-field'>
                                        <Field id="notification-form-emailSMTP-host" type="text" name="smtpHost" component={commonRenderInput} />
                                    </div>
                                    <div className="line" />
                                </Col>
                            </Row>
                            <Row className='row-stmp-account'>
                                <Col sm={12}>
                                    <div className='area-form-label'>
                                        <label className='need-star-label'>*</label><label>Email SMTP Account</label>
                                    </div>
                                    <div className='area-form-field'>
                                        <Field id="notification-form-emailSMTP-account" type="text" name="smtpAccount" component={commonRenderInput} validate={verifyAccount} />
                                    </div>
                                    <div className="line" />
                                </Col>
                            </Row>
                            <Row className='row-stmp-password'>
                                <Col sm={12}>
                                    <div className='area-form-label'>
                                        <label className='need-star-label'>*</label><label>Email SMTP Password</label>
                                    </div>
                                    <div className='area-form-field'>
                                        <Field id="notification-form-emailSMTP-password" type="password" name="smtpPwd" component={commonRenderInput} />
                                    </div>
                                    <div className="line" />
                                </Col>
                            </Row>
                            <Row className='row-stmp-port'>
                                <Col sm={12}>
                                    <div className='area-form-label'>
                                        <label className='need-star-label'>*</label><label>Email SMTP Port</label>
                                    </div>
                                    <div className='area-form-field'>
                                        <Field id="notification-form-emailSMTP-port" type="text" name="smtpPort" component={commonRenderInput} validate={verifyNumber} />
                                    </div>
                                    <div className="line" />
                                </Col>
                            </Row>
                            <Row className='row-email-from'>
                                <Col>
                                    <div className='area-form-label'>
                                        <label className='need-star-label'>*</label><label>Email From</label>
                                    </div>
                                    <div className='area-form-field'>
                                        <Field id="notification-form-email-from" type="text" name="emailFrom" component={commonRenderInput} validate={verifyAccount} />
                                    </div>
                                    <div className="line" />
                                </Col>
                                {/* <Col className='button-test'> */}
                                    {/* <Col md={2} xl={4}>&nbsp;</Col> */}
                                    {/* <Col md={8} xl={4}> */}
                                        <Button id="notification-form-test-email" className="button-test" bsPrefix='btn btn-test' variant="primary" size="lg" onClick={ () => { this.testSMTPEmail(); }} disabled={!verifyFormPass || !checkTableAuth('settings', accountRole, roleTableAuth, 2)} block><label>Test Email</label></Button>
                                    {/* </Col> */}
                                    {/* <Col md={2} xl={4}>&nbsp;</Col> */}
                                {/* </Col> */}
                            </Row>
                            <Row className='row-email-alias'>
                                <Col sm={12}>
                                    <div className='area-form-label'>
                                        <label className='need-star-label'>*</label><label>Email Alias</label>
                                    </div>
                                    <div className='area-form-field'>
                                        <Field id="notification-form-email-alias" type="text" name="emailAlias" component={commonRenderInput} />
                                    </div>
                                    <div className="line" />
                                </Col>
                            </Row>
                        </div>
                        {btnSubmit}
                    </form>
                </div>
            );
        } else {
            return (<Loading loading={true}></Loading>);
        }
    }
}

const validate = (values) => {
    const errors = {}
    if (!values.smtpHost) {
        errors.smtpHost = '* Required'
    }
    if (!values.smtpAccount) {
        errors.smtpAccount = '* Required'
    }
    if (!values.smtpPwd) {
        errors.smtpPwd = '* Required'
    }
    if (!values.smtpPort) {
        errors.smtpPort = '* Required'
    }
    if (!values.emailFrom) {
        errors.emailFrom = '* Required'
    }
    return errors
}

const getverifyField = (form) => {
    if (form) {
        let verifyFields = ['smtpHost', 'smtpAccount', 'smtpPwd', 'smtpPort', 'emailFrom'];
        return verifyFields;
    }
    else {
        return [];
    }
}

const mapStateToProps = (state, ownProps) => {
    const mailSetting = state.settingsReducers.notifyDetail;
    const verifyFormPass = verifyForm(state.form['NotificationForm'], getverifyField(state.form['NotificationForm']));
    let result = {
        formValues: getFormValues('NotificationForm')(state),
        readOnly: true,
        authToken: state.loginReducers.authToken,
        accountRole: state.loginReducers.accountRole,
        roleTableAuth: state.loginReducers.roleTableAuth,
        mailSetting: mailSetting,
        verifyFormPass: verifyFormPass,
        status: state.settingsReducers.status,
        selectSite: 1,
    }

    if (mailSetting) {
        let initialValues = {};
        initialValues['id'] = mailSetting?.['id'] ?? null;
        initialValues['smtpHost'] = mailSetting?.['smtpHost'] ?? '';
        initialValues['smtpAccount'] = mailSetting?.['smtpAccount'] ?? '';
        initialValues['smtpPwd'] = mailSetting?.['smtpPwd'] ?? '';
        initialValues['smtpPort'] = mailSetting?.['smtpPort'] ?? '';
        initialValues['emailFrom'] = mailSetting?.['emailFrom'] ?? '';
        initialValues['emailAlias'] = mailSetting?.['emailAlias'] ?? '';
        result['initialValues'] = initialValues;
    }
    return result
}

NotificationForm = reduxForm({
    form: 'NotificationForm',  // a unique identifier for this form
    validate,                  // validation function given to redux-form
    enableReinitialize: true, // When set to true, the form will reinitialize every time the initialValues prop changes.
})(NotificationForm)

export default withRouter(connect(
    mapStateToProps
    , { doGetNotifySettings, doSaveNotifySettings, popupModalConfirm, openModalAlert, openModalTip, doTestSMTPEmail }
)(NotificationForm));
